import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export interface salesOffice{
  city: string;
  code: string;
  sales_org: string;
  state: string;
  text: string;
  text_long: string;
}
export async function getSalesOffices(salesOrg: string,is_all?:any): Promise<salesOffice[]> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      is_all:is_all
    },
      url: `${BASE_URL}/api/adminsettings/deliveryPlants`,
    };

  return await AXIOS_INSTANCE(config).then((v) => v.data);
}


export async function getAllRoutes(salesOrg: any) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/adminsettings/getAllRoutes`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function deactivateRoute(
  salesOrg:  string,
  deliveryPlant: string,
  route: string,
  active: string
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      clientId: "100",
      salesOrg,
      deliveryPlant,
      route,
      active,
    },
    url: `${BASE_URL}/api/adminsettings/deactivateRoute`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function updateDriverDetails(
  salesOrg:  string,
  deliveryPlant: string,
  route: string,
  driverName: string,
  driverNumber: string
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      clientId: "100",
      salesOrg,
      deliveryPlant,
      route,
      driverName,
      driverNumber,
    },
    url: `${BASE_URL}/api/adminsettings/updateDriverDetails`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

